import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { RemovePlaceFromGroupUseCaseInterface } from 'domain/usecases';

export class RemoteRemovePlaceFromGroup
  implements RemovePlaceFromGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemovePlaceFromGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: RemovePlaceFromGroupUseCaseInterface.Params,
  ): Promise<RemovePlaceFromGroupUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.relationId}`,
      method: 'delete',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
